import { Box, ComposableTypography, ComposableTypographyProps } from '@bcp-nextgen-dx-component-factory/design-system';
import { UIHelper } from '@helpers';

import { AppTooltip, AppTooltipProps } from '../_cf';

export interface ComposableTypographyWithTooltipProps extends ComposableTypographyProps {
	tooltip?: AppTooltipProps;
}

export const ComposableTypographyWithTooltip = ({
	tooltip,
	...composableTypographyProps
}: ComposableTypographyWithTooltipProps) => {
	const tooltipMarginLeft = tooltip?.size === 'xxSmall' ? UIHelper.rem(4) : UIHelper.rem(8);

	return (
		<Box styles={{ alignItems: 'start', display: 'inline-block' }}>
			<ComposableTypography {...composableTypographyProps} />

			{tooltip && (
				<AppTooltip
					title={tooltip.title}
					description={tooltip.description}
					size={tooltip.size}
					styles={{ marginLeft: tooltipMarginLeft, ...tooltip.styles }}
				/>
			)}
		</Box>
	);
};
